import axios from '../plugins/axios'
import initValuesFromDom from '../mixins/initValuesFromDom'

export default {
  mixins: [initValuesFromDom],
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',

      current_password: '',
      new_password: '',
      confirm_password: '',
    }
  },
  beforeMount() {
    this.initValuesFromDom()
  },
  methods: {
    update_account () {
      if (this.loading) {
        return
      }

      this.loading = true
      this.messageType = 'error'
      this.errors.clear()

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    submit () {
      const formData = new FormData(this.$el)

      this.loading = true
      this.errors.clear()

      axios.post('', formData)
        .then(response => {
          this.messageType = 'success'
          this.errors.add({ msg: 'הפרטים עודכנו בהצלחה. כעת יתבצע רענון לדף..' })

          this.current_password = ''
          this.new_password = ''
          this.confirm_password = ''

          setTimeout(function() {
            location.reload()
          }, 1500)
        })
        .catch(error => {
          this.messageType = 'error'
          this.errors.add({ msg: error.response.data.data.message })
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/update_account.js